import { render, staticRenderFns } from "./pondRenewal.vue?vue&type=template&id=71f1bcfc&scoped=true&"
import script from "./pondRenewal.vue?vue&type=script&lang=js&"
export * from "./pondRenewal.vue?vue&type=script&lang=js&"
import style0 from "./pondRenewal.vue?vue&type=style&index=0&id=71f1bcfc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f1bcfc",
  null
  
)

export default component.exports